import { Component } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'app';
  sidebarVisible = true;
   showSidebar = true;

   constructor(private router: Router) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        // Ocultar sidebar y botón en ruta /login
        this.showSidebar = this.router.url !== '/login';
        // Si quieres que sidebar empiece visible en otras páginas
        if (this.showSidebar) {
          this.sidebarVisible = true;
        }
      }
    });
  }

  toggleSidebar() {
    this.sidebarVisible = !this.sidebarVisible;
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts